export default "__VITE_ASSET__877a23e3__"